export const PrintableCalendarFonts = {
  MrsEavesBold: "MrsEaves-Bold",
  MrsEavesMedium: "MrsEaves-Medium",
  ProximaNovaRegular: "ProximaNova-Regular",
  ProximaNovaSemiBold: "ProximaNova-SemiBold",
  ProximaNovaBold: "ProximaNova-Bold",
  ProximaNovaExtraBold: "ProximaNova-ExtraBold",
  ProximaNovaBlack: "ProximaNova-Black",
}